import React from 'react';
import { Paper, Typography, Button, Box, useMediaQuery } from '@mui/material';
import plural from 'plural-ru';

import { parseDate } from '../../helpers/lib';
import styles from './styles/offlineGroupsStyles';

function OfflineGroupCard({
  startDate,
  endDate,
  examDeadline,
  placesLeft,
  clickHandler,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [startWeekday, startDay, startMonth] = parseDate(startDate);
  const [endWeekday, endDay, endMonth] = parseDate(endDate);
  const [deadlineWeekday, deadlineDay, deadlineMonth] = parseDate(examDeadline);

  const placesAvailable = `осталось ${placesLeft} ${plural(
    placesLeft,
    'место',
    'места',
    'мест',
  )}`;

  return (
    <Paper sx={styles.main}>
      {startWeekday && endWeekday && (
        <Typography
          variant={isSm ? 'desktopP1' : 'desktopH4'}
          color="kit.text.h"
        >{`${startDay} ${startMonth}-${endDay} ${endMonth}`}</Typography>
      )}
      <Box sx={styles.interviewDate}>
        {deadlineWeekday && (
          <>
            <Typography variant="desktopP3">
              вступительное интервью&nbsp;
            </Typography>
            <Typography color="kit.text.secondary" variant="desktopP3">
              до {`${deadlineDay} ${deadlineMonth}`}
            </Typography>
          </>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 'auto',
          width: 'fit-content',
        }}
      >
        <Box sx={styles.placesAvailable}>
          <Typography fontSize={11} color="kit.text.secondary">
            {`<${placesAvailable || ''}>`}
          </Typography>
        </Box>
        <Button
          onClick={clickHandler}
          variant="outlined"
          size={isSm ? 'smallest' : 'medium'}
          sx={{ mt: 2 }}
        >
          Записаться на курс
        </Button>
      </Box>
    </Paper>
  );
}

export default OfflineGroupCard;
